export default "__VITE_ASSET__vVX0WpMB__"